var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1407.873,
    height: 147.277,
    viewBox: "0 0 1407.873 147.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    transform: "translate(-3154.581 -958.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    "data-name": "Trazado 273",
    d: "M4361.373,1028.151a26.028,26.028,0,0,0,7.346-18.113h0a26.155,26.155,0,0,0-26.154-26.154h-34.041a7.09,7.09,0,0,0-7.09,7.09v81.49a7.09,7.09,0,0,0,7.09,7.09h35.311c15.009,0,28.311-11.136,29.484-26.1A28.059,28.059,0,0,0,4361.373,1028.151Zm-45.945-30.278h26.761a12.605,12.605,0,0,1,0,25.211h-26.761Zm29.718,67.58h-29.718v-28.414h29.718a14.207,14.207,0,0,1,0,28.414Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    d: "M4443.1,989.9l-.623-1.491a7.331,7.331,0,0,0-6.763-4.5h0a7.33,7.33,0,0,0-6.764,4.5l-.623,1.491-33.529,80.218a6.816,6.816,0,0,0,6.288,9.444h0a6.815,6.815,0,0,0,6.288-4.187l7.507-17.959h41.666l7.507,17.959a6.815,6.815,0,0,0,6.288,4.187h0a6.816,6.816,0,0,0,6.288-9.444Zm-22.378,53.54,14.992-35.867,14.992,35.867Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    d: "M4226.753,983.2h-.118a48.882,48.882,0,0,0-48.882,48.881h0a48.882,48.882,0,0,0,48.882,48.881h.118a48.88,48.88,0,0,0,48.88-48.881h0A48.88,48.88,0,0,0,4226.753,983.2Zm-.018,83.569h-.083a34.641,34.641,0,0,1,0-69.282h.083a34.641,34.641,0,1,1,0,69.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    d: "M4074.809,1033.183h-15.423a7,7,0,1,0,0,13.994h6.422V1058a5,5,0,0,1-2.536,4.444,34.38,34.38,0,0,1-16.282,4.084h-.083c-14.78,0-28.353-9.214-32.839-23.3-7.628-23.943,10.032-45.984,32.839-45.984h.083a34.38,34.38,0,0,1,20.606,6.828,7.129,7.129,0,0,0,10.092-1.541h0a7.094,7.094,0,0,0-1.377-9.765,48.645,48.645,0,0,0-29.3-9.763h-.118c-20.934,0-40.119,13.1-46.4,33.073-10.6,33.71,14.28,64.691,46.4,64.691h.118a48.644,48.644,0,0,0,27.48-8.469,12.585,12.585,0,0,0,5.314-10.448v-23.679A4.992,4.992,0,0,0,4074.809,1033.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    d: "M4160.564,1065.369h-37.425V990.8a7,7,0,0,0-14,0v83.569a4.993,4.993,0,0,0,4.993,4.993h46.427a7,7,0,1,0,0-13.995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M4555.456,1065.517H4518.03V990.951a7,7,0,1,0-13.995,0v83.568a4.993,4.993,0,0,0,4.993,4.993h46.428a7,7,0,0,0,0-13.995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M3516.953,987.018l33.088,79.144,33.09-79.144a4.468,4.468,0,0,1,4.123-2.745h0a4.468,4.468,0,0,1,4.122,6.192l-19.554,46.771-16.359,39.129a5.877,5.877,0,0,1-5.421,3.61h0a5.876,5.876,0,0,1-5.421-3.61l-35.914-85.9a4.469,4.469,0,0,1,4.123-6.192h0A4.468,4.468,0,0,1,3516.953,987.018Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M3688.179,1073.78l-35.912-85.9a5.876,5.876,0,0,0-10.843,0l-35.913,85.9a4.469,4.469,0,0,0,8.246,3.448l9.416-22.524h47.344l9.416,22.524a4.469,4.469,0,0,0,8.246-3.448Zm-61.242-28.079,19.908-47.618,19.909,47.618Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M3494.571,1073.474l-35.912-85.9a5.877,5.877,0,0,0-10.844,0l-35.911,85.9a4.469,4.469,0,0,0,8.246,3.447l9.415-22.523h47.345l9.416,22.523a4.468,4.468,0,1,0,8.245-3.447Zm-61.242-28.079,19.909-47.617,19.908,47.617Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M3768.308,984.269h-67.582a4.5,4.5,0,1,0,0,9h29.29v82.2a4.5,4.5,0,0,0,9,0v-82.2h29.29a4.5,4.5,0,1,0,0-9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M3863.523,1073.475l-35.912-85.9a5.877,5.877,0,0,0-10.845,0l-35.912,85.9a4.469,4.469,0,1,0,8.246,3.448l9.417-22.524h47.345l9.415,22.524a4.469,4.469,0,1,0,8.246-3.448Zm-61.242-28.078,19.907-47.618L3842.1,1045.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M3927.857,1033.564h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M3941.176,1039.661a29.131,29.131,0,0,0-12.493-55.394l-32.954,0a4.986,4.986,0,0,0-4.986,4.985v86.225a4.5,4.5,0,0,0,4.5,4.5h0a4.5,4.5,0,0,0,4.5-4.5v-32.907h28.8a29.243,29.243,0,0,0,4-.305l15.774,35.077a4.469,4.469,0,0,0,4.076,2.636h0a4.47,4.47,0,0,0,4.076-6.3Zm-12.542-6.1h-28.888V993.285h28.873a20.14,20.14,0,0,1,20.14,20.139h0a20.36,20.36,0,0,1-20.125,20.138Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9573",
    "data-name": "Trazado 9573",
    d: "M3277.956,1094.411c5.455,4.664,10.359,10.241,20.806,11,27.635,1.281,38.961-24.193,24.6-44.97l-1.875-2.823a54.128,54.128,0,0,0-76.537-1.219q-.3.3-.6.6l-2.258,2.263Z",
    fill: "#004aa8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10857",
    "data-name": "Grupo 10857"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4736",
    "data-name": "Rect\\xE1ngulo 4736",
    width: 32.731,
    height: 32.731,
    rx: 16.363,
    transform: "translate(3296.882 958.18)",
    fill: "#004aa8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9573-2",
    "data-name": "Trazado 9573",
    d: "M3206.23,1094.411c-5.454,4.664-10.358,10.241-20.806,11-27.635,1.281-38.96-24.193-24.6-44.97l1.875-2.823a54.127,54.127,0,0,1,76.536-1.219c.2.2.4.4.606.6l2.258,2.263Z",
    fill: "#36c1ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M3262.639,968.966a24.916,24.916,0,0,0-20.546-10.789h0a24.914,24.914,0,0,0-20.545,10.789l-58.854,88.654q.3-.3.6-.6a54.125,54.125,0,0,1,76.545-.019l2.258,2.258h0l2.258-2.258a54.126,54.126,0,0,1,76.546.019q.3.3.6.6Z",
    fill: "#00ace6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.440fd419.svg";
export { ForwardRef as ReactComponent };